export default class Pagination {

  private _offset = 0;
  private _limit = 0;
  private _total = 0;
  
  public reset() {
    this.offset = 0;
    this.limit = 0;
    this.total = 0;
  }

  public get offset(): number {
    return this._offset;
  }
  public set offset(value: number) {
    this._offset = value;
  }
  public get limit(): number {
    return this._limit;
  }
  public set limit(value: number) {
    this._limit = value;
  }
  public get total(): number {
    return this._total;
  }
  public set total(value: number) {
    this._total = value;
  }
}